export var I18nDefaultConfig = {
  fallbackLng: 'en',
  loadPath: '/locales/{{lng}}/{{ns}}.json',
  supportedLngs: ['ru', 'en'],
  useSuspense: true,
  version: 'default'
};
export var I18nLangsLabels = {
  ru: {
    labelShort: 'Ру',
    labelFull: 'Русский'
  },
  en: {
    labelShort: 'En',
    labelFull: 'English'
  }
};